import React, { createContext, useContext, useMemo } from 'react';
import translations from './translations';

const LanguageContext = createContext({ lang: 'en', t: translations.en });

export const LanguageProvider = ({ lang = 'en', children }) => {
  const value = useMemo(() => ({ lang, t: translations[lang] ?? translations.en }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;
